import {
  feedFactoryAxios,
  internalToExternal,
} from "helpers";
import { InternalEventItemModel } from "models/Ndtrc";

export const postNewEvent = (
  eventItem: InternalEventItemModel,
  id: string | null
) => {
  return feedFactoryAxios.post("/events", internalToExternal(eventItem));
};
